<template>
  <div class='h100vh-140'>
    <div class="h-toolbarBg">
      <ejs-toolbar>
        <e-items>
          <e-item v-if="sysOrCustom === 1" prefixIcon='icon hero-icon hero-icon-add' :tooltipText='$t("System.createTask")' :click="showTimingDialog"></e-item>
          <e-item v-if="sysOrCustom === 1" prefixIcon='icon hero-icon hero-icon-remove' :tooltipText='$t("System.delTask")' :click="confirmDel"></e-item>
          <e-item prefixIcon='icon hero-icon hero-icon-start-up' :tooltipText='$t("System.activeTask")' :click="activeMission"></e-item>
          <e-item prefixIcon='icon hero-icon hero-icon-disable' :tooltipText='$t("System.deactiveTask")' :click="deactiveMission"></e-item>
          <e-item prefixIcon='icon hero-icon hero-icon-edit' :tooltipText='$t("System.editTask")' :click="editMission"></e-item>
          <e-item prefixIcon='icon hero-icon hero-icon-refresh' :tooltipText='$t("Alarm.refresh")' :click="refreshList"></e-item>
          <e-item prefixIcon='icon hero-icon hero-icon-filter' :tooltipText='$t("System.taskFilter")' :click="showFilterDialog"></e-item>
        </e-items>
      </ejs-toolbar>
      <div class="h-inputBox">
        <input class="e-input" :placeholder="missionKey" @keyup.enter="inputQuery" v-model="keyString" />
      </div>
    </div>
    <div class="h100-40 h-scroll">
      <ejs-grid ref="grid" height='calc(100vh - 280px)' :allowPaging="true"  :pageSettings="pageSettings">
        <e-columns>
          <e-column field="sysTaskId" :headerText='$t("System.taskId")' width="120" textAlign="Center" clipMode='EllipsisWithTooltip'></e-column>
          <e-column field="sysTaskName" :headerText='$t("System.taskName")' width='150' textAlign="Center" clipMode='EllipsisWithTooltip'></e-column>
          <e-column field="taskSwitch" :headerText='$t("System.isEffective")' width="130" textAlign="Center"></e-column>
          <e-column field="sysTaskState" :headerText='$t("System.state")' width="120" textAlign="Center"></e-column>
          <e-column field="sysTaskOsType" :headerText='$t("System.oprType")' width="170" textAlign="Center"></e-column>
          <e-column field="moduleName" :headerText='$t("System.module")' width="120" textAlign="Center" clipMode='EllipsisWithTooltip'></e-column>
          <e-column field="begTimeString" :headerText='$t("System.startTime")' width="130" textAlign="Center" clipMode='EllipsisWithTooltip'></e-column>
          <e-column field="endTimeString" :headerText='$t("System.endTime")' width="130" textAlign="Center" clipMode='EllipsisWithTooltip'></e-column>
          <e-column field="nextTimeString" :headerText='$t("System.nextTime")' width="170" textAlign="Center" clipMode='EllipsisWithTooltip'></e-column>
          <e-column field="sysTaskNextOs" :headerText='$t("System.lastResult")' width="120" textAlign="Center" clipMode='EllipsisWithTooltip'></e-column>
          <e-column field="sysTaskEfitRemark" :headerText='$t("System.description")' width='150' textAlign="Center" clipMode='EllipsisWithTooltip'></e-column>
        </e-columns>
      </ejs-grid>
      <ejs-pager ref="pager" :pageSize="pageSettings.pageSize" :pageCount="pageCount" @click="getMissionList"></ejs-pager>
    </div>
    <CustomDialog ref="timingDialog" v-bind:element="timingDialog.element" v-bind:styles="timingDialog.styles">
      <template v-slot:dialog-content>
        <TimingMission ref="timeMission" v-bind:createOrEdit="createOrEdit" v-bind:sysCustom="sysOrCustom" @childProps="getChildProps"></TimingMission>
      </template>
    </CustomDialog>
    <CustomDialog ref="filterDialog" v-bind:element="filterDialog.element" v-bind:styles="filterDialog.styles">
      <template v-slot:dialog-content>
        <TaskFilter ref="taskFilter"  @filterProps="getFilterProps" v-bind:sysCustom="sysOrCustom" />
      </template>
    </CustomDialog>
  </div>
</template>

<script>
import CustomDialog from "../common/CustomDialog";
import TimingMission from "./TimingMission";
import TaskFilter from "./TaskFilter";
import {EventBus} from "../../plugins/eventBus";

export default {
  name: "MissionList",
  data() {
    return {
      items: [
        { text: `${this.$t('System.result')}`, iconCss: "e-ddb-icons e-dashboard" },
        { text: `${this.$t('System.reSuccess')}` },
        { text: `${this.$t('System.reFault')}` }
      ],
      pageSettings: { pageSize: 15 },
      keyString: "",
      sysOrCustom: 0, // 0 系统任务 1 自定义任务
      pageNo: "1",
      pageCount: "4",
      missionKey: `${this.$t('System.taskSearchKey')}`,
      childProps: {},
      createOrEdit: 0,
      condition : {},
      timingDialog: {
        element: {
          // target: "#app",
          isClose: true,
          refName: "timingMission",
          buttonGroup: [
            {
              click: this.dialogHide,
              buttonModel: { content: `${this.$t('System.cancel')}`}
            },
            {
              click: this.confirmMission,
              buttonModel: { content: `${this.$t('System.confirm')}`, isPrimary: true }
            }
          ],
          title: `${this.$t('System.createTask')}`
        },
        styles: {
          width: "810px",
          height: "auto",
          model: true,
          visible: false
        }
      },
      filterDialog: {
        element: {
          isClose: true,
          refName: "timeFilter",
          buttonGroup: [
            {
              click: this.filterHide,
              buttonModel: { content: `${this.$t('System.cancel')}`}
            },
            {
              click: this.confirmSearch,
              buttonModel: { content: `${this.$t('System.confirm')}`, isPrimary: true }
            }
          ],
          title: `${this.$t('System.taskFilter')}`
        },
        styles: {
          width: "510px",
          height: "auto",
          model: true,
          visible: false
        }
      },
      taskSwitch: [{ text: `${this.$t('System.no')}`, value: 0 }, { text: `${this.$t('System.yes')}`, value: 1 }],
      sysTaskState: [
        { text: `${this.$t('System.isRunning')}`, value: "1" },
        { text: `${this.$t('System.isReady')}`, value: "2" },
        { text: `${this.$t('System.isInvalid')}`, value: "3" },
        { text: `${this.$t('System.pause')}`, value: "0" }
      ],
      sysTaskOsType: [
        { text: `${this.$t('System.mmlMiss')}`, value: "1" },
        { text: `${this.$t('System.db')}`, value: "2" },
        { text: `${this.$t('System.systemFile')}`, value: "3" }
      ],
      moduleName: [
        { text: `${this.$t('System.config')}`, value: 1 },
        { text: `${this.$t('System.fm')}`, value: 2 },
        { text: `${this.$t('System.alarm')}`, value: 3 },
        { text: `${this.$t('System.spectrum')}`, value: 7 },
        { text: `${this.$t('System.systemManager')}`, value: 5 }
      ]
    };
  },
  components: {
    CustomDialog,
    TimingMission,
    TaskFilter
  },
  methods: {
    confirmSearch() {
      this.getMissionList();
      this.$refs.filterDialog.close();
    },
    showFilterDialog(){
      this.$refs.filterDialog.show();
    },
    getFilterProps(data){
      this.condition = data;
    },
    refreshList(){
      this.$loading.showLoadding(`${this.$t('SubscriberIms.fresh')}`);
      this.getMissionList();
    },
    getMissionList() {
      this.$loading.hideLoadding();
      // 系统任务0 or 自定义任务1
      this.pageNo = this.$refs.pager.ej2Instances.currentPage;
      const url = "/lte/ems/sysmanager/task/gettaskbypage";
      //const taskSwitch = this.condition.taskSwitch;
      //const taskState = this.condition.taskState;
      const params = {
        sysTaskOsType: this.condition.taskType,
        moduleId: this.condition.moduleName,
        keystring: this.keyString,
        sysOrCustom: this.sysOrCustom,
        pageNo: this.pageNo,
        pageSize: this.pageSettings.pageSize
      };
      if(this.condition.taskResult != ""){
        params.sysTaskNextOs = this.condition.taskResult;
      }
      this.axios.get(url,  {params}).then(response => {
        const result = response.data.result;
        if (result == null || result == "") {
          this.$refs.grid.ej2Instances.dataSource = [];
          this.$refs.pager.ej2Instances.totalRecordsCount = response.data.totalCount;
          return null;
        }
        const showRe = [];
        const currentTime = new Date().getTime();
        result.forEach(e => {
          if(e.sysTaskEndTime != null && e.sysTaskEndTime <= currentTime && e.sysTaskState == '2'){
            e.taskSwitch = 0;
            e.sysTaskState = '3';
          }
          /*if(taskSwitch != '' && taskSwitch != e.taskSwitch){
            return true;
          }
          if(taskState !='' && taskState != e.sysTaskState){
            return true;
          }*/
          const show = {};
          show.sysTaskId = e.taskIdString;
          show.sysTaskName = e.sysTaskName;
          show.begTimeString = e.begTimeString;
          show.endTimeString = e.endTimeString;
          show.nextTimeString = e.nextTimeString;
          show.sysTaskNextOs = e.sysTaskNextOs;
          show.sysTaskEfitRemark = e.sysTaskEfitRemark;
          this.taskSwitch.forEach(item => {
            if (item.value === e.taskSwitch) {
              show.taskSwitch = item.text;
            }
          });
          this.sysTaskState.forEach(item => {
            if (item.value === e.sysTaskState) {
              show.sysTaskState = item.text;
              show.sysState = item.value;
            }
          });
          this.sysTaskOsType.forEach(item => {
            if (item.value === e.sysTaskOsType) {
              show.sysTaskOsType = item.text;
            }
          });
          this.moduleName.forEach(item => {
            if (item.value === e.moduleId) {
              show.moduleName = item.text;
            }
          });
          if(e.taskSwitch == 0 || e.sysTaskState == "3"){
            show.nextTimeString = "";
          }
          showRe.push(show);
        });
        this.$refs.grid.ej2Instances.dataSource = showRe;
        this.$refs.pager.ej2Instances.totalRecordsCount = response.data.totalCount;
      });
    },
    inputQuery(){
      this.$refs.pager.ej2Instances.currentPage = 1;
      this.getMissionList();
    },
    init(sysCustom) {
      this.keyString = "";
      this.sysOrCustom = sysCustom;
      this.getMissionList();
    },
    showTimingDialog() {
      this.createOrEdit = 0;
      this.timingDialog.element.title = `${this.$t('System.createTask')}`;
      this.$refs.timingDialog.show();
      this.$refs.timeMission.bindValidate();
    },
    editMission() {
      let record = this.getRecord();
      if (record == null) {
        return;
      }
      const url = "/lte/ems/sysmanager/task/gettaskbypk";
      let params = { systaskid: record[0].sysTaskId };
      this.axios.get(url, { params }).then(response => {
        const editParams = response.data;
        this.createOrEdit = 1;
        this.timingDialog.element.title = `${this.$t('System.editTask')}`;
        this.$refs.timeMission.backfillParams(editParams);
        this.$refs.timingDialog.show();
        this.$refs.timeMission.bindValidate();
      });
    },
    confirmMission() {
      const validate = this.$refs.timeMission.validate();
      if (!validate) {
        return null;
      }
      const timeValidate = this.$refs.timeMission.getCornValue();
      if (!timeValidate){
        return false;
      }
      const params = this.childProps;
      if (this.sysOrCustom === 1){
        const filesname = params.filesname;
        if (filesname.length === 0){
          EventBus.$emit('toast', {type: 'warning', content: this.$t('System.selectFile')});
          return false;
        }
        if(params.sysTaskEndTime != "" && params.sysTaskEndTime != undefined &&
          (Date.parse(params.sysTaskEndTime) < Date.parse(params.sysTaskBegTime))){
          EventBus.$emit('toast', {type: 'warning', content: this.$t('System.endDateInvalid')});
          return false;
        }
      }
      let url = "";
      if (this.createOrEdit === 0) {
        url = "/lte/ems/sysmanager/task/addtask";
      } else {
        url = "/lte/ems/sysmanager/task/modtask";
      }
      this.dialogHide();
      this.axios.post(url, params).then(response => {
        if (response.data) {
          EventBus.$emit('toast', {type: 'success', content: this.$t('Common.tips.success')});
          const That = this;
          setTimeout(function () {
            That.getMissionList();
          },100);
        }else{
          EventBus.$emit('toast', {type: 'error', content: this.$t('Common.tips.failure')});
        }
      });
    },
    saveGroupName() {
      const url = "/lte/ems/sysmanager/task/saveGroupName";
      const params = { groupNameList: [], sysTaskId: this.childProps.sysTaskId };
      this.axios.post(url, params).then(response => {

      });
    },
    getChildProps(data) {
      this.childProps = data;
    },
    delTimingMission() {
      this.dialogHide();
      const url = "/lte/ems/sysmanager/task/deltask";
      let record = this.getRecord();
      if (record == null) {
        return;
      }
      let params = { sysTaskId: record[0].sysTaskId };
      this.axios.post(url, params).then(response => {
        if (response.data) {
          EventBus.$emit('toast', {type: 'success', content: this.$t('Common.tips.success')});
          this.getMissionList();
        }else{
          EventBus.$emit('toast', {type: 'error', content: this.$t('Common.tips.failure')});
        }
      });
    },
    activeMission() {
      const url = "/lte/ems/sysmanager/task/activetask";
      let record = this.getRecord();
      if (record == null) {
        return null;
      }
      //如果是过期的不可激活
      if(record[0].sysState == 3){
        EventBus.$emit('toast', {type: 'warning', content: this.$t('System.taskPastDue')});
        return null;
      }

      let params = { sysTaskId: record[0].sysTaskId };
      this.axios.get(url, { params }).then(response => {
        const result = response.data;
        if(result){
          EventBus.$emit('toast', {type: 'success', content: this.$t('Common.tips.success')});
        }else{
          EventBus.$emit('toast', {type: 'error', content: this.$t('Common.tips.failure')});
        }
        this.getMissionList();
      });
    },
    deactiveMission() {
      const url = "/lte/ems/sysmanager/task/deactivetask";
      let record = this.getRecord();
      if (record == null) {
        return null;
      }
      if(record[0].sysState == 3){
        EventBus.$emit('toast', {type: 'warning', content: this.$t('System.taskPastDue')});
        return null;
      }
      let params = { sysTaskId: record[0].sysTaskId };
      this.axios.get(url, { params }).then(response => {
        const result = response.data;
        if(result){
          EventBus.$emit('toast', {type: 'success', content: this.$t('Common.tips.success')});
        }else{
          EventBus.$emit('toast', {type: 'error', content: this.$t('Common.tips.failure')});
        }
        this.getMissionList();
      });
    },
    dialogHide() {
      this.$refs.timingDialog.clear();
      this.$refs.timingDialog.close();
    },
    filterHide() {
      this.$refs.filterDialog.clear();
      this.$refs.filterDialog.close();
    },

    getRecord() {
      const record = this.$refs.grid.ej2Instances.getSelectedRecords();
      if (record == null || record == "") {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('System.selectOneMessage')});
        return null;
      }
      return record;
    },
    confirmDel() {
      const record = this.getRecord();
      if (record == null) {
        return null;
      }
      this.$layer.confirm({
        msg: this.$t('System.confirmDel'),
        btn1: {
          msg: this.$t('System.cancel'),
        },
        btn2: {
          msg: this.$t('System.confirm'),
          func: ()=>{
            this.delTimingMission();
          }
        }
      });
    }
  }
};
</script>
